<template>
  <div id="app">
    <transition name="fade">
      <RouterView />
    </transition>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Watch } from 'vue-property-decorator'

@Component
export default class App extends Vue {
  get routePath(): string {
    return this.$route.path
  }

  get nextPath(): string | null | undefined {
    return localStorage.getItem('next-path') !== this.routePath ? localStorage.getItem('next-path') : undefined
  }

  get isAuthenticated(): boolean {
    return this.$store.getters.isAuthenticated
  }

  mounted() {
    this.navigateToNextPath()
  }

  @Watch('routePath')
  navigateToNextPath() {
    if (this.nextPath && this.isAuthenticated) {
      if (this.nextPath !== this.$route.fullPath)
        this.$router.push({ path: this.nextPath }).then(() => localStorage.removeItem('next-path'))
      else localStorage.removeItem('next-path')
    }
  }
}
</script>

<style lang="scss" src="@/styles/index.scss" />
